import { useAtomValue } from 'jotai'
import React from 'react'

import { auth0UserAtom } from '~/atoms'
import { useInvalidateCommonQuery } from '~/hooks/useCommonQuery'

/**
 * ユーザーが更新されたらCommonQueryを無効にするカスタムフックです。
 */
export const useInvalidateCommonQueryOnAuth0UserUpdateEffect = () => {
  const auth0User = useAtomValue(auth0UserAtom)
  const invalidateCommonQuery = useInvalidateCommonQuery()

  React.useEffect(() => {
    invalidateCommonQuery()
  }, [auth0User, invalidateCommonQuery])
}
